import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { GuidedTourStateModel, GuidedTourStatus } from '../models/guided-tour-state.model';
import { GetGuidedTourToggleStatus, SetGuidedTourToggleStatus } from './guided-tour.actions';

const defaults = {
  toggleOn: false
} as GuidedTourStateModel;

@State<GuidedTourStateModel>({
  name: 'guidedTour',
  defaults: {
    ...defaults,
  },
})
@Injectable()
export class GuidedTourState {
  constructor() { }

  @Action(GetGuidedTourToggleStatus)
  getToggleStatus(ctx: StateContext<GuidedTourStateModel>) {
    return ctx.getState().toggleOn;
  }

  @Action(SetGuidedTourToggleStatus)
  setToggleStatus(ctx: StateContext<GuidedTourStateModel>, action: SetGuidedTourToggleStatus) {
    // always set to false first to force tour to start
    const state = ctx.getState();
    ctx.setState({
      ...state,
      toggleOn: false,
    });
    if (action.status === GuidedTourStatus.ON ) {
      ctx.setState({
        ...state,
        toggleOn: true,
      });
    }
  }
}

